import { delay } from '../delay';
import { b64_to_utf8 } from '../../app/base64';
import _ from 'lodash';

export class PropertyAPI {

    static listeners = [];

    static properties = [
        { id: '64eb44d08d3fce17ca391be7', name: "54MVR", doorNumberOrName: "54", roadName: "Manorville Road", town: "Hemel Hempstead", postCode: "HP3 0AP", landlordOrOwner: "Russet Properties", image: "/assets/img/pos/54MNV.jpg", imageDimensions: { w: 300, h: 200 }, selectedProject: 2, propertyType: 1 },
        { id: '64eb44d18d3fce17ca391be8', name: "15VXR", doorNumberOrName: "15", roadName: "Vauxhall Road", town: "Hemel Hempstead", postCode: "HP2 4HW", landlordOrOwner: "Russet Properties", image: "/assets/img/pos/15VXR.jpg", imageDimensions: { w: 300, h: 200 }, propertyType: 1 },
        { id: '64eb44d18d3fce17ca391be9', name: "27ORCH", doorNumberOrName: "27", roadName: "Orchard Mead", town: "Hatfield", postCode: "AL10 0SB", landlordOrOwner: "Maria Properties", propertyType: 1 },
        { id: '64eb44d18d3fce17ca391bea', name: "75ATH", doorNumberOrName: "75", roadName: "Atherstone Road", town: "Luton", postCode: "LU4 8QU", landlordOrOwner: "Graham Bould", propertyType: 1 },
    ];

    static additionalSearchProperties = [
        { id: '6447e7926e6ee23e577d2ad0', name: "22BEL", doorNumberOrName: "22", roadName: "Bourne End Lane", town: "Hemel Hempstead", postCode: "HP1 2RL", landlordOrOwner: "Russet Properties", image: "/assets/img/pos/22BEL.jpg", imageDimensions: { w: 300, h: 261 }, propertyType: 0 },
    ];

    listenForUpdates = (updateName, subscriberCallback) => {

        const listener = _.find(PropertyAPI.listeners, l => l.name === updateName);
        if (!listener) {
            PropertyAPI.listeners.push({ name: updateName, callback: subscriberCallback });
        }
        else {
            // replace the whole listener...
            const listenerIndex = _.findIndex(PropertyAPI.listeners, l => l.name === updateName);
            PropertyAPI.listeners.splice(listenerIndex, 1); // Remove current version
            PropertyAPI.listeners.splice(listenerIndex, 0, { name: updateName, callback: subscriberCallback }); // Insert new version in its place
        }
    };

    getTop10 = (url, accessToken) => {

        return new Promise((resolve, reject) => { // eslint-disable-line no-unused-vars
            setTimeout(() => {

                console.log(`Getting property items from '${url}', using token:`, accessToken);

                resolve(Object.assign([], PropertyAPI.properties));

            }, delay.value());
        });
    };

    find = (url, accessToken) => {

        return new Promise((resolve, reject) => { // eslint-disable-line no-unused-vars
            setTimeout(() => {

                console.log(`Searching property items from '${url}', using token:`, accessToken);

                const urlParams = new URL(url).searchParams;
                const searchTerm = b64_to_utf8(urlParams.get('searchTerm'));

                const searchResult = [];
                const allProperties = [].concat(PropertyAPI.properties, PropertyAPI.additionalSearchProperties);

                for (const property of allProperties) {

                    let match = false;

                    for (const memberName in property) {
                        let member = property[memberName].toString();

                        if (member.search(new RegExp(searchTerm, "i")) > -1) {
                            match = true;
                            break;
                        }
                    }

                    if (match) {
                        searchResult.push(property);
                        match = false;
                    }
                }

                resolve(Object.assign([], searchResult));

            }, delay.value());
        });
    };

    get = (id, accessToken) => {

        return new Promise((resolve, reject) => { // eslint-disable-line no-unused-vars
            setTimeout(() => {

                console.log(`Loading property '${id}', using token:`, accessToken);

                const allProperties = [].concat(PropertyAPI.properties, PropertyAPI.additionalSearchProperties);

                const property = _.find(allProperties, p => p.id.toString() === id.toString());

                resolve(Object.assign({}, property));

            }, delay.value());
        });
    }

    upsertProperty = (property, accessToken) => {


        return new Promise((resolve, reject) => { // eslint-disable-line no-unused-vars
            setTimeout(() => {

                console.log(`Upserting property '${property.id}', using token:`, accessToken);

                let thisProperty = {};
                let index = _.findIndex(PropertyAPI.properties, p => p.id.toString() === property.id.toString());
                if (index > -1) {

                    PropertyAPI.properties.splice(index, 1); // Remove current version
                    PropertyAPI.properties.splice(index, 0, property); // Insert new version in its place
                }
                else {
                    index = _.findIndex(PropertyAPI.additionalSearchProperties, p => p.id.toString() === property.id.toString());
                    PropertyAPI.additionalSearchProperties.splice(index, 1); // Remove current version
                    PropertyAPI.additionalSearchProperties.splice(index, 0, property); // Insert new version in its place
                }

                const allProperties = [].concat(PropertyAPI.properties, PropertyAPI.additionalSearchProperties);
                thisProperty = _.find(allProperties, p => p.id.toString() === property.id.toString());

                const listener = _.find(PropertyAPI.listeners, l => l.name === "propertyUpdate");

                if (listener) {
                    listener.callback(thisProperty);
                }

                resolve(Object.assign({}, thisProperty));

            }, delay.value());
        });
    }
}